import { render } from "./InactivityWarning.vue?vue&type=template&id=5643a494&scoped=true"
import script from "./InactivityWarning.vue?vue&type=script&lang=js"
export * from "./InactivityWarning.vue?vue&type=script&lang=js"

import "./InactivityWarning.vue?vue&type=style&index=0&id=5643a494&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5643a494"]])

export default __exports__